import { CheckCircleOutline, CircleOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';


export default function LikertQuestion(props) {

    const {i18n, t} = useTranslation()

    const index = props.surveyUserData.findIndex((el) => el.questionId === props.questionId)
    const answer = index !== -1 ? props.surveyUserData[index].answer : null
    const setAnswer = (index) => {
        props.updateSurveyData(props.questionId, index)
        props.updateChangeBehaviour(props.questionId, answer, index);
    }

    const nChoices = 5

    const renderChoices = () => {

        const choices = [];

        for (let i = 0; i < nChoices; i++) {
            if (i === answer) {
                choices.push(
                    <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}} key={i}>
                        <IconButton color="primary" sx={{width: "fit-content"}}>
                            <CheckCircleOutline/>
                        </IconButton>
                    </Box>
                )

            } else {
                choices.push(
                    <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}} key={i}>
                        <IconButton  onClick={() => setAnswer(i)} sx={{width: "fit-content"}}>
                            <CircleOutlined/>
                        </IconButton>
                    </Box>
                )
            }
        }

        return choices;
    }

    return(
        <Box sx={{width: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <Typography sx={{fontWeight: 500}}>{props.question[i18n.language]}</Typography>
            <Box sx={{mb: 2, mt: 2}}>
                <Box sx={{display: "flex", justifyContent: "space-around"}}>
                    {renderChoices()}
                </Box>
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                    <Typography align="center">{t("likertReject")}</Typography>
                    <Typography align="center">{t("likertApprove")}</Typography>
                </Box>
            </Box>
        </Box>
    )
}